<template>
  <section class="vd-error-component">
    <h1 class="error-number">{{ status }}</h1>
    <h2 class="message">{{ message }}</h2>
    <router-link v-if="backLink" :to="backLink">go back</router-link>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { RouteLocationRaw } from "vue-router";

export default defineComponent({
  name: "VDError",

  props: {
    status: {
      type: [String, Number],
      required: true,
    },

    message: {
      type: String,
      required: true,
    },

    backLink: {
      type: Object as PropType<RouteLocationRaw>,
      default: () => null,
    },
  },
});
</script>

<style lang="scss" scoped>
.vd-error-component {
  display: inline-block;
  position: relative;
  margin-top: size("ML");
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 40%;
  padding: size("ML");

  .error-number {
    font-size: font("XL") * 10;
    font-weight: bold;
    color: var(--voodootune-highlight-color);
    opacity: 0.8;

    margin: 0;
    position: absolute;
    top: 0;
    left: -25%;
    z-index: -1;
  }

  .message {
    font-size: font("XL");
    margin-bottom: size("S");
    line-height: 30px;
    word-break: break-word;
  }
}
</style>
